import(/* webpackMode: "eager" */ "/vercel/path0/frontend/public/images/sponsors/avaty.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/frontend/public/images/sponsors/synchro.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/frontend/public/images/sponsors/tns.png");
;
import(/* webpackMode: "eager", webpackExports: ["BackgroundContainer","SVGBackground","GlowEllipse"] */ "/vercel/path0/frontend/src/app/components/Background/styles.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/src/app/components/Cards/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Landing"] */ "/vercel/path0/frontend/src/app/components/Landing/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IgnorePageWidth","Flex","HR","Text","CarouselFlex","Title","Button","VL"] */ "/vercel/path0/frontend/src/app/styles.ts");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_@opentelemetry+api@1.9.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/image-component.js");
